import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import logo from './../../assets/img/logo-tanta.svg'

class BotonMenu extends Component {
  render() {
    return (
      <div className = "button-menu">
        <div className="columns is-mobile">
          <div className="column button-menu-content content-izq">
            <Link to="/">
              <img className="logo-menu" src={logo} alt="Tanta" />
            </Link>
          </div>

          <div className="column button-menu-content content-der" onClick={this.props.activeMenu}>
            <div className="hamburger">
              <div className={`menui top-menu ${this.props.isActive ? 'top-animate' : '' }`}></div>
              <div className={`menui mid-menu ${this.props.isActive ? 'mid-animate' : ''}`}></div>
              <div className={`menui bottom-menu ${this.props.isActive ? 'bottom-animate' : ''}`}></div>
            </div>
          </div>
        </div>
      </div>
    )
  } 
}

export default BotonMenu;